// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"add0c2f5","952":"eaaf99fc"}[chunkId] + ".chunk.js";
};